'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ID_CARD = exports.ID_CARD = 'ID_CARD';
var CARD_COMPONENT_TYPE_NAME = exports.CARD_COMPONENT_TYPE_NAME = 'Card';
var CARD_COMPONENT_ITEM_TYPE_NAME = exports.CARD_COMPONENT_ITEM_TYPE_NAME = 'CardItem';
var ADVANCED_CARD_TYPE_NAME = exports.ADVANCED_CARD_TYPE_NAME = 'AdvancedCard';
var CARD_COMPONENT_TYPE_NAME_LIST = exports.CARD_COMPONENT_TYPE_NAME_LIST = [CARD_COMPONENT_TYPE_NAME, ADVANCED_CARD_TYPE_NAME];
var AUTO_COLUMNS_LAYOUT = exports.AUTO_COLUMNS_LAYOUT = 'AutoColumnsLayout';
var COLUMNS_LAYOUT = exports.COLUMNS_LAYOUT = 'ColumnsLayout';

var FIELD_DATA_VALUE_KEY = exports.FIELD_DATA_VALUE_KEY = 'fieldData.value.result';